import { removeSessionStorageState } from './sessionStorageHelper';
export var openLink = function openLink(url) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_self';
  return url && window.open(url, target);
};
export var redirectTo = function redirectTo(url) {
  if (url) {
    removeSessionStorageState();
    openLink(url);
  }
};